import React from "react";
import { SovosBox, SovosTypography } from "mosaic-react";
import { SovosAIIcon } from "mosaic-react-platform";
import { AI_BRAND_GRADIENT_PINK } from "mosaic-react-platform/shared/aiBrandGradient";

const AiConfidencePill = ({ score, title = "Suggested by Sovos Intelligence" }) => {
    if (score == null) return null;
    const pct = Math.round(score * 100);

    return (
        <SovosBox
            title={title}
            sx={{
                alignItems: "center",
                bgcolor: `${AI_BRAND_GRADIENT_PINK}1F`,
                borderRadius: 999,
                display: "inline-flex",
                flexShrink: 0,
                gap: 0.375,
                px: 0.75,
                py: 0.25,
                whiteSpace: "nowrap",
            }}
        >
            <SovosBox
                sx={{
                    alignItems: "center",
                    display: "flex",
                    "& svg": { height: 12, width: 12 },
                }}
            >
                <SovosAIIcon />
            </SovosBox>
            <SovosTypography sx={{ color: "#BE185D", fontSize: 10, fontWeight: 600 }}>
                {pct}%
            </SovosTypography>
        </SovosBox>
    );
};

export default AiConfidencePill;
